import type { Calculations } from '@features/glossary';
import type { Slide } from '@features/powerpoint';
import { pageV2 } from './components/page-v2';

export type CalculationsPaginationConfig = {
  entriesPerColumnPerPage: number[];
  totalPages: number;
};

type CalculationsSlidesV2Props = {
  title: string;
};

export const calculationsSlidesV2 = (
  calculations: Calculations,
  pagination: CalculationsPaginationConfig,
  props: CalculationsSlidesV2Props
): Slide[] =>
  Array.from(
    { length: pagination.totalPages },
    (_, pageIndex): Slide =>
      pageV2(calculations, pageIndex, pagination.entriesPerColumnPerPage, {
        title: props.title,
      })
  );
